import { call, put } from "redux-saga/effects";
import { authService } from "../services/authService";
import { authConstants } from "../actions/constants/authConstants";
import { commonConstants } from "@/actions/constants/commonConstants";
import { onboardingConstants } from "@/actions/constants/onboardingConstants";
import { localData, sessionData } from "@/services/helper";
import { localKeys } from "@/utils/constants";

function* userLogin(action: any): any {
    try {
        const response = yield call(authService.userLogin, action.payload);
        if (response.success) {
            // persist auth data for session restore
            try {
                const payload = response.resultObject;
                localData.set(localKeys.authData, payload);
                sessionData.set(localKeys.authData, payload);
            } catch (e) {}
            yield put({ type: authConstants.userLoginSuccess, payload: response.resultObject });
            yield put({ type: commonConstants.showSuccessMessage, payload: response.message });
        } else {
            yield put({ type: authConstants.userLoginFailure, payload: response.errorMessage });
            yield put({ type: commonConstants.showErrorMessage, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: authConstants.userLoginFailure, payload: error });
    }
}

function* userLogout(action: any): any {
    try {
        const deviceId = localData.get<string>(localKeys.deviceId);
        const response = yield call(authService.userLogout, deviceId);
        if (response.success) {
            localData.remove(localKeys.authData);
            sessionData.remove(localKeys.authData);
        } else {
          
        }
    } catch (e) {}
    yield put({ type: authConstants.userLogoutSuccess });
}

function* verifyOtp(action: any): any {
    try {
        const response = yield call(authService.verifyOtp, action.payload);
        if (response.success) {
            yield put({ type: authConstants.userVerifyOtpSuccess, payload: response.resultObject });
            yield put({ type: commonConstants.showSuccessMessage, payload: response.message });
        } else {
            yield put({ type: authConstants.userVerifyOtpFailure, payload: response.errorMessage });
            yield put({ type: commonConstants.showErrorMessage, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: authConstants.userVerifyOtpFailure, payload: error });
    }
}

function* verifyInvite(action: any): any {
    try {
        const response = yield call(authService.verifyInvite, action.payload);
        if (response.success) {
            yield put({ type: authConstants.verifyInviteSuccess, payload: response.resultObject });
            yield put({ type: commonConstants.showSuccessMessage, payload: response.message });
        } else {
            yield put({ type: authConstants.verifyInviteFailure, payload: response.errorMessage });
            yield put({ type: commonConstants.showErrorMessage, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: authConstants.verifyInviteFailure, payload: error });
    }
}

function* userResendInvite(action: any): any {
    try {
        const response = yield call(authService.userResendInvite, action.payload);
        if (response.success) {
            yield put({
                type: authConstants.userResendInviteSuccess,
                payload: response.resultObject,
            });
            yield put({
                type: onboardingConstants.inviteUserSuccess,
                payload: response.resultObject,
            });
            yield put({ type: commonConstants.showSuccessMessage, payload: response.message });
        } else {
            yield put({
                type: authConstants.userResendInviteFailure,
                payload: response.errorMessage,
            });
            yield put({ type: commonConstants.showErrorMessage, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: authConstants.userResendInviteFailure, payload: error });
    }
}

function* sendOtp(action: any): any {
    try {
        const response = yield call(authService.sendOtp, action.payload);
        if (response.success) {
            yield put({ type: authConstants.sendOtpSuccess, payload: response.resultObject });
            yield put({ type: commonConstants.showSuccessMessage, payload: response.message });
        } else {
            yield put({ type: authConstants.sendOtpFailure, payload: response.errorMessage });
            yield put({ type: commonConstants.showErrorMessage, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: authConstants.sendOtpFailure, payload: error });
    }
}

function* resendOtp(action: any): any {
    try {
        const response = yield call(authService.resendOtp, action.payload);
        if (response.success) {
            yield put({ type: authConstants.resendOtpSuccess, payload: response.resultObject });
            yield put({ type: commonConstants.showSuccessMessage, payload: response.message });
        } else {
            yield put({ type: authConstants.resendOtpFailure, payload: response.errorMessage });
            yield put({ type: commonConstants.showErrorMessage, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: authConstants.resendOtpFailure, payload: error });
    }
}

export const authSaga = {
    userLogin,
    userLogout,
    verifyOtp,
    verifyInvite,
    userResendInvite,
    sendOtp,
    resendOtp,
};
